export default async function sendStats(backend, eventType, data) {
  // fetch('https://my-app.telekinesis.workers.dev/', {
  //   method: 'POST',
	//   headers: {"content-type": "application/json"},
	//   body: JSON.stringify({
  //     eventType: eventType,
  //     sessionKey: await backend._session.sessionKey.publicSerial(),
  //     data: data
  //   })
  // }).then(async r => console.log( await r.text()))
  return await backend.logEvent(eventType, data);
}